import { render, staticRenderFns } from "./FcImage.vue?vue&type=template&id=71abfd8a&scoped=true&"
import script from "./FcImage.vue?vue&type=script&lang=ts&"
export * from "./FcImage.vue?vue&type=script&lang=ts&"
import style0 from "./FcImage.vue?vue&type=style&index=0&id=71abfd8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71abfd8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
